import React from 'react';
import { Column } from 'react-foundation';
import { Icon } from '../../components/Icon';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button'

interface Props {
	dataPerSim: number;
	moisPerSim: number;
	price: number;
	currentOrder: object;
	isUnlimited: (value: any) => boolean;
}

const Centralize = styled.div`
  margin: auto;
  text-align: center;
`;

const TextContainer = styled.ul`
  margin: auto;
  text-align; left;
  max-width: 16rem;
  list-style-type: none;
`;

const Head = styled.h4`
  text-align: center;
  line-height: 125%;
`;

const Section = styled.div`
  margin-top: 2rem;
`;

export const CurrentOrderIndicator: React.FC<Props> = (props: Props) => {
	return (
		<Column large={6} small={12}>
		<Section>
		  <Centralize>
			<Icon name="medium--cart" />
		  </Centralize>
		  <Head>Muokkaa data-, puhe- ja viestimäärää</Head>
		  {props.currentOrder && (
			<TextContainer>
			  <li>Jokaiseen liittymään sisältyy keskimäärin </li>
			  <li>* {props.isUnlimited(props.dataPerSim) ? 'Rajattomasti' : `${props.dataPerSim} gt` } dataa</li>
			  <li>* {props.moisPerSim} puheminuuttia tai viestiä</li>
			  <li>Hinta {props.price} €/kk</li>
			</TextContainer>
			)}
		  <Centralize>
			<Link to={'/account/order'} >
			  <Button>
				Muokkaa paketteja
			  </Button>
			</Link>
		  </Centralize>
		</Section>
	  </Column>
	);
};